import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import EditUtilityForm from "../form/edit/EditUtilityForm";
import Utility from "../../../../model/utility/Utility";

interface IComponentProps {
	/**
	 * On close button click.
	 */
	onClose: () => void;
	/**
	 * Utility to edit
	 */
	editedUtility: Utility;
}

export default class EditUtilityModal extends React.Component<IComponentProps, {}> {
	render() {
		return (
			<Modal autoWidth onCloseClicked={this.props.onClose} title={"Edit Utility"}>
				<EditUtilityForm closeModal={this.props.onClose}
								 editedUtility={this.props.editedUtility}/>
			</Modal>
		);
	}
}